import type { IconData } from '@stacksjs/iconify-core'

export const callHangUpFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M46.483 14.556C45.925 32.293 31.372 46.5 13.5 46.5c-6.833 0-12-5.335-12-12.069a4.5 4.5 0 0 1 2.829-4.178l6.165-2.466a5.5 5.5 0 0 1 5.932 1.217l3.076 3.077c.136.136.289.152.382.124a18.55 18.55 0 0 0 12.32-12.32c.029-.094.013-.247-.123-.383l-3.077-3.076a5.5 5.5 0 0 1-1.217-5.932l2.466-6.165A4.5 4.5 0 0 1 34.431 1.5c7.365 0 12.166 5.861 12.052 13.056\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M7.232 7.232a2.5 2.5 0 0 1 3.536 0l36 36a2.5 2.5 0 0 1-3.536 3.536l-36-36a2.5 2.5 0 0 1 0-3.536\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default callHangUpFlat
